var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1305px",
    height: "833px",
    viewBox: "0 0 1305 833",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1305,
    height: 833
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.22044605e-14%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-2.22044605e-14%",
    y2: "50%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393939",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "-2.22044605e-14%",
    y2: "50%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7A7A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.22044605e-14%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.22044605e-14%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6C6C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.22044605e-14%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E0E0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations-Dark-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-161.721811,860.516216 C165.456218,860.516216 344.30879,417 683.806265,417 C1023.30374,417 1236.26387,860.516216 1533.7802,860.516216 C1831.29653,860.516216 -368.793721,860.516216 -161.721811,860.516216 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)",
    opacity: 0.519999981,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-752.274807,865.018919 C-450.101317,865.018919 -284.91753,475.535135 28.6338953,475.535135 C342.18532,475.535135 538.87,865.018919 813.648684,865.018919 C1088.42737,865.018919 -943.521273,865.018919 -752.274807,865.018919 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.957482,860.516216 C672.773886,860.516216 834.482558,471.032432 1141.43753,471.032432 C1448.3925,471.032432 1640.93935,860.516216 1909.93728,860.516216 C2178.93521,860.516216 189.734434,860.516216 376.957482,860.516216 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)",
    opacity: 0.800000012,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-755.291017,961.827027 C-524.740696,961.827027 -398.709869,610.616216 -159.478487,610.616216 C79.7528953,610.616216 229.818065,961.827027 439.466878,961.827027 C649.115692,961.827027 -901.206974,961.827027 -755.291017,961.827027 Z",
    id: "Shape",
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape",
    fill: "url(#linearGradient-7)",
    mask: "url(#mask-2)",
    cx: 276,
    cy: 227.124324,
    rx: 90,
    ry: 90.0540541
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape",
    fill: "url(#linearGradient-8)",
    opacity: 0.200000003,
    mask: "url(#mask-2)",
    cx: 276.25,
    cy: 227.337838,
    rx: 146.25,
    ry: 146.337838
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder3);
export default __webpack_public_path__ + "static/media/placeholder-3.e51cc4a52bac5ac1864568c61b602b4d.svg";
export { ForwardRef as ReactComponent };